<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10.65 1.94187C10.721 1.53379 11.1093 1.26053 11.5174 1.33154C15.1626 1.9658 18.0324 4.83557 18.6666 8.48076C18.7376 8.88884 18.4644 9.27722 18.0563 9.34822C17.6482 9.41923 17.2599 9.14598 17.1888 8.73789C16.6631 5.71641 14.2818 3.33507 11.2603 2.80933C10.8522 2.73833 10.579 2.34995 10.65 1.94187Z"
            fill="currentColor"
        />
        <path
            d="M18.0563 10.6482C18.4644 10.7192 18.7376 11.1076 18.6666 11.5157C18.0324 15.1608 15.1626 18.0306 11.5174 18.6649C11.1093 18.7359 10.721 18.4626 10.65 18.0545C10.579 17.6465 10.8522 17.2581 11.2603 17.1871C14.2818 16.6613 16.6631 14.28 17.1888 11.2585C17.2599 10.8504 17.6482 10.5772 18.0563 10.6482Z"
            fill="currentColor"
        />
        <path
            d="M2.81104 11.2585C2.74004 10.8504 2.35166 10.5772 1.94358 10.6482C1.53549 10.7192 1.26224 11.1076 1.33325 11.5157C1.96751 15.1608 4.83728 18.0306 8.48247 18.6649C8.89055 18.7359 9.27893 18.4626 9.34993 18.0545C9.42094 17.6465 9.14768 17.2581 8.7396 17.1871C5.71812 16.6613 3.33678 14.28 2.81104 11.2585Z"
            fill="currentColor"
        />
        <path
            d="M9.34993 1.94187C9.42094 2.34995 9.14768 2.73833 8.7396 2.80933C5.71812 3.33507 3.33678 5.71641 2.81104 8.73789C2.74004 9.14598 2.35166 9.41923 1.94358 9.34822C1.53549 9.27722 1.26224 8.88884 1.33325 8.48076C1.96751 4.83557 4.83728 1.9658 8.48247 1.33154C8.89055 1.26053 9.27893 1.53379 9.34993 1.94187Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.99994 6.7482C8.20502 6.7482 6.74994 8.20328 6.74994 9.9982C6.74994 11.7931 8.20502 13.2482 9.99994 13.2482C11.7949 13.2482 13.2499 11.7931 13.2499 9.9982C13.2499 8.20328 11.7949 6.7482 9.99994 6.7482ZM8.24994 9.9982C8.24994 9.0317 9.03344 8.2482 9.99994 8.2482C10.9664 8.2482 11.7499 9.0317 11.7499 9.9982C11.7499 10.9647 10.9664 11.7482 9.99994 11.7482C9.03344 11.7482 8.24994 10.9647 8.24994 9.9982Z"
            fill="currentColor"
        />
    </svg>
</template>
